import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TooltipHover = (props) => {
  const node = useRef(null);

  useEffect(() => {
    const $node = $(node.current);
    if (typeof $node.tooltip !== "function") return;
    $node.tooltip();

    return () => {
      $node.tooltip("destroy");
    };
  }, [props.tooltip]);

  return (
    <div
      ref={node}
      className={`${props.inline ? "inline ml-3" : "float-right relative"} ${
        props.className ? props.className : ""
      }`}
      style={{ color: props.icon_color ? props.icon_color : undefined }}
      tabIndex={0}
      aria-label={props.tooltip}
      data-placement={props.placement || "top"}
      title={props.tooltip}
    >
      {props.image ? (
        <img
          src={props.image}
          alt=""
          className="inline-block h-[1em] w-auto align-[-0.125em]"
        />
      ) : (
        <FontAwesomeIcon icon={props.icon} size={props.icon_size} />
      )}
    </div>
  );
};

export default TooltipHover;
